
import { TranslationsByLanguage, PluralTranslation } from './types';

export type CreatorsTranslationKey =
  | 'creators.allCreators'
  | 'creators.title'
  | 'creators.subtitle'
  | 'creators.noCreators'
  | 'creators.creations'
  | 'creators.readMore'
  | 'creators.showLess'
  | 'creators.creationCount';

export const creatorsTranslations: TranslationsByLanguage = {
  en: {
    'creators.allCreators': 'All Creators',
    'creators.title': 'Creators',
    'creators.subtitle': 'Discover talented creators and their derivative works',
    'creators.noCreators': 'No creators found',
    'creators.creations': 'creations',
    'creators.readMore': 'Read more',
    'creators.showLess': 'Show less',
    'creators.creationCount': {
      zero: 'No creation',
      one: '1 creation',
      other: '{count} creations'
    } as PluralTranslation
  },
  fr: {
    'creators.allCreators': 'Tous les Créateurs',
    'creators.title': 'Créateurs',
    'creators.subtitle': 'Découvrez des créateurs talentueux et leurs œuvres dérivées',
    'creators.noCreators': 'Aucun créateur trouvé',
    'creators.creations': 'créations',
    'creators.readMore': 'Lire plus',
    'creators.showLess': 'Voir moins',
    'creators.creationCount': {
      zero: 'Aucune création',
      one: '1 création',
      other: '{count} créations'
    } as PluralTranslation
  }
};
